import { Progress } from "antd";
import ReactCountryFlag from "react-country-flag";

export default function TopCountryList({
  countrycode,
  countryname,
  percent = 0,
  ...props
}) {
  return (
    <div
      {...props}
      className="w-full flex flex-row justify-between items-center gap-10"
    >
      <div className="w-[160px] justify-start items-center gap-2.5 flex">
        <ReactCountryFlag
          countryCode={countrycode}
          svg
          style={{
            width: "24px",
            height: "24px",
          }}
          title={countrycode}
        />
        <p className="text-[#222222] text-sm font-normal font-['Open Sans']">
          {countryname}
        </p>
      </div>
      <div className="w-[100%] pt-1">
        <Progress percent={percent} strokeColor="#310048" size={["100%", 15]} />
      </div>
    </div>
  );
}
